import { CategoryType } from '../components/ContractorInfo';

export const getListByName = (searchTerm: string, array: CategoryType[]) => {
  const selectedCategory = array.find(category => category.name === searchTerm);
  return selectedCategory ? selectedCategory.array : [];
};
